// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#root {
  width: 100%;
}
.bg-warning-subtle {
  background-color: #fff3cd !important;
}

.shadow-sm {
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08) !important;
}

.rounded-3 {
  border-radius: 1rem !important;
}

.global-submit-loader-overlay {
  position: fixed;
  inset: 0;
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(15, 23, 42, 0.35);
  backdrop-filter: blur(2px);
}

.global-submit-loader-card {
  min-width: 240px;
  padding: 20px 24px;
  border-radius: 14px;
  background: #ffffff;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.25);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

.global-submit-loader-spinner {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  border: 4px solid #e2e8f0;
  border-top-color: rgb(168, 187, 33);
  animation: global-submit-spin 0.8s linear infinite;
}

.global-submit-loader-text {
  color: #1f2937;
  font-size: 14px;
  font-weight: 600;
}

@keyframes global-submit-spin {
  to {
    transform: rotate(360deg);
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,WAAW;AACb;AACA;EACE,oCAAoC;AACtC;;AAEA;EACE,wDAAwD;AAC1D;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF","sourcesContent":["#root {\n  width: 100%;\n}\n.bg-warning-subtle {\n  background-color: #fff3cd !important;\n}\n\n.shadow-sm {\n  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.08) !important;\n}\n\n.rounded-3 {\n  border-radius: 1rem !important;\n}\n\n.global-submit-loader-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 9999;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(15, 23, 42, 0.35);\n  backdrop-filter: blur(2px);\n}\n\n.global-submit-loader-card {\n  min-width: 240px;\n  padding: 20px 24px;\n  border-radius: 14px;\n  background: #ffffff;\n  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.25);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n}\n\n.global-submit-loader-spinner {\n  width: 42px;\n  height: 42px;\n  border-radius: 50%;\n  border: 4px solid #e2e8f0;\n  border-top-color: rgb(168, 187, 33);\n  animation: global-submit-spin 0.8s linear infinite;\n}\n\n.global-submit-loader-text {\n  color: #1f2937;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n@keyframes global-submit-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
